<template>
  <div>
    <v-alert
      v-if="currentByod.length > 0 && currentByod[0].status.code == 'submitted'"
      type="error"
      text
      :prominent="!$vuetify.breakpoint.xs"
    >
      <v-row align="center">
        <v-col>
          Du hast den Beitrag für dein persönliches Gerät im Jahr
          {{ year }} eingereicht. Vergiss nicht, die Rechnung auszudrucken und
          zu unterschreiben, damit sie bearbeitet werden kann.
        </v-col>
        <v-col cols="auto">
          <ReportButton
            depressed
            resource="report/invoice"
            :parameters="{ id: currentByod[0].id }"
            color="danger"
            >Rechnung</ReportButton
          >
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-else-if="
        currentByod.length > 0 && currentByod[0].status.code == 'rejected'
      "
      type="error"
      color="danger"
      text
      :prominent="!$vuetify.breakpoint.xs"
    >
      Dein Antrag für den BYOD-Beitrag wurde zurückgewiesen. Bitte lösche den
      Antrag, damit du einen neuen einreichen kannst.
    </v-alert>
    <v-alert
      v-else-if="
        currentByod.length > 0 && currentByod[0].status.code == 'entered'
      "
      type="success"
      text
      :prominent="!$vuetify.breakpoint.xs"
    >
      Du hast den Beitrag für dein persönliches Gerät im Jahr
      {{ year }} bereits bezogen.
    </v-alert>
    <v-alert
      v-else-if="currentByod.length > 0"
      type="info"
      text
      :prominent="!$vuetify.breakpoint.xs"
    >
      Dein Antrag für den BYOD-Beitrag
      {{ year }} wird bearbeitet.
    </v-alert>
    <v-alert v-else type="info" text :prominent="!$vuetify.breakpoint.xs">
      Du hast den Beitrag für dein persönliches Gerät im Jahr
      {{ year }} noch nicht bezogen. Bitte gib deine IBAN ein (oder kontrolliere
      die erfasste Nummer), um den Antrag einzureichen.
      <v-row class="mt-4" align="center">
        <v-col>
          <v-text-field
            light
            hideDetails
            v-model="iban"
            label="IBAN"
            :rules="[validIban]"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-btn
            color="success"
            depressed
            :disabled="!canCreate || creating"
            @click="create"
            ><v-icon>mdi-plus</v-icon>einreichen</v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
    <v-card v-if="!$vuetify.breakpoint.smAndDown">
      <v-system-bar>Rechnungen BYOD-Beiträge</v-system-bar>
      <InvoiceTable :items="items" page="FinanceByod" />
    </v-card>
    <template v-else>
      <InvoiceCards :items="items" page="FinanceByod" />
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import DateValue from "common/components/DateValue.vue";
import ReportButton from "@/components/ReportButton.vue";

import InvoiceCards from "../Invoice/Components/InvoiceCards.vue";
import InvoiceTable from "../Invoice/Components/InvoiceTable.vue";

import { isValidIBANNumber, getIban } from "common/utils/finance.js";
import { today, formatYear } from "common/utils/date";

export default defineComponent({
  name: "Byod",
  components: {
    CurrencyValue,
    DateValue,
    ReportButton,
    InvoiceCards,
    InvoiceTable,
  },
  data() {
    return {
      iban: null,
      items: [],
      loading: false,
      creating: false,
      today: today(),
      validIban: (value) => {
        return isValidIBANNumber(value) || "Ungültige IBAN.";
      },
    };
  },
  computed: {
    year() {
      return formatYear(this.today);
    },
    currentByod() {
      if (!this.items) {
        return false;
      }
      return this.items.filter((item) => item.date.includes(this.year));
    },
    canCreate() {
      if (this.currentByod.length > 0) {
        return false;
      }
      if (!this.iban) {
        return;
      }
      if (!isValidIBANNumber(this.iban)) {
        return;
      }
      return true;
    },
  },
  methods: {
    async create() {
      this.creating = true;
      await this.apiPost({
        resource: "finance/byod",
        data: {
          iban: this.iban,
        },
      });
      this.creating = false;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/byod",
      });
      this.loading = false;
    },
    show(item) {
      this.$router.push(`/invoice/${item.id}`);
    },
  },
  async created() {
    this.fetchData();
    this.iban = await getIban();
  },
});
</script>
